import { FollowsGeoBorder } from "../../../../core/geo/types";
import { wfsService } from "../../../../api/api-packages/wfs-service/wfsService.service";
import { Feature, LineString } from "geojson";
import { PortalLineSegment, PortalLineSegmentType } from "../../../../portal/segment/types";

const getGeoBordersMapping = async (geoBorderIds: string[], envParams: string) => {
    const borders = await wfsService({
        typeName: "avitech:Geoborder",
        ENV: encodeURIComponent(envParams),
        CQL_FILTER: `FEATURE_ID IN (${geoBorderIds.join()})`,
    });
    return new Map(
        borders.features.map((border) => {
            return [border.properties.featureId!.toString(), border];
        })
    );
};

export const populateGeoBorderSegmentCoordinates = async (
    segments: PortalLineSegment[],
    envParams: string
): Promise<PortalLineSegment[]> => {
    const geoBorderIds = segments
        .filter((segment) => segment.type === PortalLineSegmentType.FOLLOWS_GEO_BORDER)
        .map((segment) => (segment as PortalLineSegment<FollowsGeoBorder>).properties.geoBorderId);
    let geoBorders: Map<string, Feature>;
    if (geoBorderIds.length > 0) {
        geoBorders = await getGeoBordersMapping(geoBorderIds, envParams);
    }
    return segments.map((segment) => {
        if (segment.type === PortalLineSegmentType.FOLLOWS_GEO_BORDER) {
            const geoBorderSegment = segment as PortalLineSegment<FollowsGeoBorder>;
            const geoBorder = geoBorders.get(geoBorderSegment.properties.geoBorderId);
            if (!geoBorder) {
                throw Error(`GeoBorder '${geoBorderSegment.properties.geoBorderId}' not found`);
            }
            return {
                type: PortalLineSegmentType.FOLLOWS_GEO_BORDER,
                properties: {
                    ...segment.properties,
                    geoBorderCoordinates: (geoBorder.geometry as LineString).coordinates,
                },
            };
        }
        return { ...segment };
    });
};
